import React from 'react';

import SocialMenu from '../SocialMenu';

export default function EventSocialMenu({ event }) {
    const { _isCommunity, settings } = event ?? {},
        { linkedin_url, twitter_url, facebook_url, insta_url, youtube_url, primary_color } = settings ?? {};

    if (!event || !settings) return null;

    return (
        <SocialMenu
            linkedin={linkedin_url}
            twitter={twitter_url}
            facebook={facebook_url}
            instagram={insta_url}
            youtube={youtube_url}
            info={_isCommunity ? './info' : null}
            style={{ backgroundColor: primary_color }}
        />
    );
}
